<template>
    <b-container fluid>
        <validation-observer
            v-if="metadata"
            :initialValues="{
                reservation_deposit: metadata.payment_schedule.reservation_deposit,
                balance_period_amount: metadata.payment_schedule.balance_period_amount,
            }"
            ref="form"
            class="w-100"
            v-slot="{ meta, setFieldValue, errors }"
        >
            <b-row class="pt-2">
                <b-col md="5" class="column-wrapper">
                    <b-row class="no-gutters align-items-baseline row-wrapper flex-md-row flex-column pb-2">
                        <span>Reservation Deposit = </span>
                        <validation-provider
                            name="reservation_deposit"
                            :rules="`maxValueOrEqual:${maxDepositValue}|validPositiveOrZeroFloat|required`"
                        >
                            <form-input
                                class="mb-md-2 mb-0"
                                type="number"
                                v-model="metadata.payment_schedule.reservation_deposit"
                                :error="errors.reservation_deposit"
                                @input="(val) => setFieldValue('reservation_deposit', val)"
                            ></form-input>
                        </validation-provider>

                        <form-select
                            class="mb-md-2 mb-0"
                            @input="onChangeDepositIsFlat"
                            v-model="metadata.payment_schedule.deposit_is_flat"
                            :options="depositOptions"
                        ></form-select>
                        <span> due at time of reservation.</span>
                    </b-row>
                    <b-row class="no-gutters balance-column flex-md-row flex-column">
                        <span>Reservation Deposit: </span>
                        <form-checkbox
                            :disabled="metadata.payment_schedule.deposit_is_flat"
                            v-model="metadata.payment_schedule.include_services"
                        >
                            Include Services
                        </form-checkbox>
                        <form-checkbox
                            :disabled="metadata.payment_schedule.deposit_is_flat"
                            v-model="metadata.payment_schedule.include_fees"
                        >
                            Include Fees
                        </form-checkbox>
                        <form-checkbox
                            :disabled="metadata.payment_schedule.deposit_is_flat"
                            v-model="metadata.payment_schedule.include_taxes"
                        >
                            Include Taxes
                        </form-checkbox>
                    </b-row>
                    <b-row class="no-gutters flex-column balance-column">
                        <span>Balance amount is paid:</span>

                        <b-form-radio
                            @input="onChangeNoBalance"
                            :value="true"
                            v-model="metadata.payment_schedule.no_balance_period"
                            name="balance-amount"
                        >
                            on arrival
                        </b-form-radio>
                        <b-form-radio
                            @input="onChangeNoBalance"
                            class="form-radio-wrapper"
                            :value="false"
                            v-model="metadata.payment_schedule.no_balance_period"
                            name="balance-amount"
                        >
                            <validation-provider
                                name="balance_period_amount"
                                :rules="
                                    !metadata.payment_schedule.no_balance_period &&
                                    `maxValueOrEqual:9999|validPositiveOrZeroFloat|required`
                                "
                            >
                                <form-input
                                    :error="errors.balance_period_amount"
                                    class="mb-0"
                                    :disabled="metadata.payment_schedule.no_balance_period"
                                    type="number"
                                    v-model="metadata.payment_schedule.balance_period_amount"
                                    @input="(val) => setFieldValue('balance_period_amount', val)"
                                ></form-input>
                            </validation-provider>
                            <form-select
                                class="mb-0"
                                :disabled="metadata.payment_schedule.no_balance_period"
                                :options="balancePeriodOptions"
                                v-model="metadata.payment_schedule.balance_period"
                            ></form-select>
                            <span>prior to arrival.</span>
                        </b-form-radio>
                    </b-row>
                    <b-row class="no-gutters pt-2">
                        <b-button :disabled="meta.disabled" @click="submitMetadata" variant="primary">Save</b-button>
                    </b-row>
                </b-col>
            </b-row>
        </validation-observer>
    </b-container>
</template>

<script>
    import formInput from '../generic/form-input/form-input.vue';
    import formSelect from '../generic/form-select/form-select.vue';
    import formCheckbox from '../generic/form-checkbox/form-checkbox.vue';
    import { mapGetters } from 'vuex';
    import { formatResponseError } from '../../utils/api';
    export default {
        name: 'reservationDeposit',
        data() {
            return {
                paymentSchedule: null,
            };
        },
        components: {
            formInput,
            formSelect,
            formCheckbox,
        },

        computed: {
            ...mapGetters('propertyManager', ['metadata']),
            maxDepositValue() {
                return this.metadata && this.metadata.payment_schedule.deposit_is_flat ? 9999999999 : 100;
            },
            depositOptions() {
                return [
                    { text: 'fixed', value: true },
                    { text: 'percent %', value: false },
                ];
            },
            balancePeriodOptions() {
                return [
                    { text: 'days', value: 'D' },
                    { text: 'weeks', value: 'W' },
                    { text: 'months', value: 'M' },
                ];
            },
        },
        methods: {
            onChangeDepositIsFlat(value) {
                if (value) {
                    this.$store.commit('propertyManager/setMetadata', {
                        ...this.metadata,
                        payment_schedule: {
                            ...this.metadata.payment_schedule,
                            include_services: false,
                            include_fees: false,
                            include_taxes: false,
                        },
                    });
                }
            },
            onChangeNoBalance(value) {
                if (value) {
                    this.$store.commit('propertyManager/setMetadata', {
                        ...this.metadata,
                        payment_schedule: {
                            ...this.metadata.payment_schedule,
                            balance_period_amount: 0,
                        },
                    });
                }
            },
            async submitMetadata() {
                try {
                    this.$parent.$emit('handleBusy', true);
                    await this.$store.dispatch('propertyManager/submitMetadata', this.metadata.payment_schedule);
                    this.successToast({
                        text: 'Data saved successfully',
                    });
                } catch (error) {
                    const { generic, fields } = formatResponseError(error);
                    this.errorToast({
                        text: generic || 'Could not submit metadata',
                    });
                    this.$refs.form.setErrors(fields);
                } finally {
                    this.$parent.$emit('handleBusy', false);
                }
            },
        },
    };
</script>

<style scoped lang="scss">
    @import '~bootstrap/scss/_functions.scss';
    @import '~bootstrap/scss/_variables.scss';
    @import '~bootstrap/scss/mixins/_breakpoints.scss';

    .column-wrapper {
        gap: 12px;
        display: flex;
        flex-direction: column;
    }

    .balance-column {
        gap: 12px;
    }

    .row-wrapper {
        gap: 5px;
    }

    .form-radio-wrapper {
        :deep(label) {
            display: flex;
            align-items: baseline;
            gap: 5px;

            &::before,
            &::after {
                top: 0.7rem;
            }
        }
    }

    @include media-breakpoint-down(md) {
        .form-radio-wrapper {
            :deep(label) {
                flex-direction: column;

                span,
                fieldset {
                    width: 100%;
                }
            }
        }

        .row-wrapper {
            span,
            fieldset {
                width: 100%;
            }
        }
    }
</style>
